import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/leftArrowFilled.svg'
import _imports_1 from '@/assets/rightArrowFilled.svg'
import _imports_2 from '@/assets/addImage.svg'
import _imports_3 from '@/assets/sortBy.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-c0c440ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "flex justify-between items-center h-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "headerText" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
], -1))
const _hoisted_5 = { class: "mt-5 tabsHeight bg-white w-full border border-lightgrey pt-5 relative rounded" }
const _hoisted_6 = {
  key: 0,
  class: "group-buttons px-5"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow left-0"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "arrow right-0"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "px-5" }
const _hoisted_12 = { class: "flex flex-row borderBottom cursor-pointer tab-container" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "progressbarB rounded h-1" }, null, -1))
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "flex flex-col justify-between h-full" }
const _hoisted_18 = { class: "px-5 pt-2 scrollingHeight" }
const _hoisted_19 = {
  class: "w-full pr-2 h-full overflow-y-auto scrollBarColour",
  ref: "scrollContainerOrg"
}
const _hoisted_20 = { class: "row flex flex-row w-full" }
const _hoisted_21 = { class: "w-1/2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Organisation Legal Name", -1))
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_25 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_26 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "The Organization Name already exists.", -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "w-1/2 leftspacing" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Display Name", -1))
const _hoisted_31 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_32 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_33 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_34 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Display Name already exists.", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "formcontainer flex flex-col" }
const _hoisted_38 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_39 = { class: "w-1/2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Website", -1))
const _hoisted_41 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_42 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_43 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_44 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_45 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "websiteUrl already exists.", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "w-1/2 leftspacing" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Organisation Key", -1))
const _hoisted_50 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_51 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_52 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_53 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Organization Key already exists.", -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "formcontainer flex flex-col" }
const _hoisted_57 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_58 = { class: "w-1/2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Region", -1))
const _hoisted_60 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_61 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_62 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_63 = { class: "w-1/2 leftspacing" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Industry Sector", -1))
const _hoisted_65 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_66 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_67 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_68 = { class: "upperspacing" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Address line - 1", -1))
const _hoisted_70 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_71 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_72 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_73 = { class: "upperspacing" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Address line - 2", -1))
const _hoisted_75 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_76 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_77 = { class: "formcontainer flex flex-col" }
const _hoisted_78 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_79 = { class: "w-1/2" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "City", -1))
const _hoisted_81 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_82 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_83 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_84 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_85 = { class: "w-1/2 leftspacing" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "State", -1))
const _hoisted_87 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_88 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_89 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_90 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_91 = { class: "formcontainer flex flex-col" }
const _hoisted_92 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_93 = { class: "w-1/2" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Country", -1))
const _hoisted_95 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_96 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_97 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_98 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_99 = { class: "w-1/2 leftspacing" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Pincode", -1))
const _hoisted_101 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_102 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_103 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_104 = { class: "formcontainer flex flex-col" }
const _hoisted_105 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_106 = { class: "w-1/2" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Primary Contact Name", -1))
const _hoisted_108 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_109 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_110 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_111 = {
  key: 2,
  class: "text-red-500 text-xs"
}
const _hoisted_112 = { class: "w-1/2 leftspacing" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Primary Contact Mail Id", -1))
const _hoisted_114 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_115 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_116 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_117 = {
  key: 2,
  class: "error-text text-xs"
}
const _hoisted_118 = { class: "formcontainer flex flex-col" }
const _hoisted_119 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_120 = { class: "w-1/2" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Job Title", -1))
const _hoisted_122 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_123 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_124 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_125 = { class: "w-1/2 leftspacing" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Team", -1))
const _hoisted_127 = ["value"]
const _hoisted_128 = { class: "row w-full upperspacing" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Logo", -1))
const _hoisted_130 = { class: "flex justify-center" }
const _hoisted_131 = { class: "flex justify-center" }
const _hoisted_132 = ["htmlFor"]
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "w-20 h-20 cursor-pointer"
}, null, -1))
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = ["htmlFor"]
const _hoisted_136 = ["id"]
const _hoisted_137 = { class: "flex justify-center items-center mt-2" }
const _hoisted_138 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_139 = { class: "text-xs font-bold" }
const _hoisted_140 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_141 = {
  key: 1,
  class: "border w-full rounded py-2 border-lightgrey"
}
const _hoisted_142 = ["htmlFor"]
const _hoisted_143 = ["src"]
const _hoisted_144 = ["htmlFor"]
const _hoisted_145 = ["id"]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-center cursor-pointer" }, "Click on the icon/logo for uploading a file", -1))
const _hoisted_147 = { class: "flex justify-center items-center mt-2" }
const _hoisted_148 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_149 = { class: "text-xs font-bold" }
const _hoisted_150 = {
  class: "absolute bottom-0 w-40 rounded-b-sm h-14 flex justify-end items-center bg-white",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_151 = { class: "buttonposition flex justify-end items-center mx-5" }
const _hoisted_152 = ["disabled"]
const _hoisted_153 = { key: 1 }
const _hoisted_154 = { class: "flex flex-col justify-between h-full" }
const _hoisted_155 = { class: "px-5 pt-2 scrollingHeight" }
const _hoisted_156 = { class: "w-full h-full pr-2 overflow-y-auto scrollBarColour" }
const _hoisted_157 = { class: "h-3/6 flex flex-wrap gap-10" }
const _hoisted_158 = ["onChange"]
const _hoisted_159 = { class: "h-full rounded relative flex justify-center cursor-pointer items-center" }
const _hoisted_160 = ["value"]
const _hoisted_161 = { class: "h-full w-full flex justify-center items-center text-base uppercase font-semibold" }
const _hoisted_162 = {
  class: "absolute bottom-0 w-40 rounded-b-sm h-14 flex justify-end items-center bg-white",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_163 = { class: "buttonposition flex justify-end items-center mx-5" }
const _hoisted_164 = ["disabled"]
const _hoisted_165 = { key: 2 }
const _hoisted_166 = { class: "flex flex-col justify-between h-full" }
const _hoisted_167 = { class: "px-5 pt-2 scrollingHeight" }
const _hoisted_168 = { class: "w-full h-full pr-2 overflow-y-auto scrollBarColour" }
const _hoisted_169 = { class: "h-3/6 flex flex-wrap gap-10" }
const _hoisted_170 = ["onChange"]
const _hoisted_171 = { class: "h-full rounded relative flex justify-center cursor-pointer items-center" }
const _hoisted_172 = ["value"]
const _hoisted_173 = { class: "h-full w-full flex justify-center items-center text-base uppercase font-semibold" }
const _hoisted_174 = {
  class: "absolute bottom-0 w-40 rounded-b-sm h-14 flex justify-end items-center bg-white",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_175 = { class: "buttonposition flex justify-end items-center mx-5" }
const _hoisted_176 = ["disabled"]
const _hoisted_177 = { key: 3 }
const _hoisted_178 = { class: "pt-2 scrollingHeight" }
const _hoisted_179 = { class: "w-full h-full pr-2 overflow-y-auto scrollBarColour" }
const _hoisted_180 = { class: "flex flex-col justify-between" }
const _hoisted_181 = { class: "h-3/6 px-5" }
const _hoisted_182 = { class: "border-b border-lightgrey flex justify-between pb-2" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "header" }, "History")
  ])
], -1))
const _hoisted_184 = { class: "buttonposition flex justify-end items-center" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-3 mr-2.5"
}, null, -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-3 mr-2.5 rotate-180"
}, null, -1))
const _hoisted_187 = { class: "flex" }
const _hoisted_188 = {
  key: 0,
  class: "initials"
}
const _hoisted_189 = {
  key: 1,
  class: "initials"
}
const _hoisted_190 = { class: "logContainer w-93" }
const _hoisted_191 = { class: "flex mt-1" }
const _hoisted_192 = {
  key: 0,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_193 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_194 = {
  key: 2,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_195 = { key: 0 }
const _hoisted_196 = { class: "pl-2" }
const _hoisted_197 = { key: 1 }
const _hoisted_198 = { class: "pl-2" }
const _hoisted_199 = {
  key: 3,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_200 = { key: 0 }
const _hoisted_201 = { class: "pl-2" }
const _hoisted_202 = { key: 1 }
const _hoisted_203 = { class: "pl-2" }
const _hoisted_204 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_205 = { class: "pl-2" }
const _hoisted_206 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_207 = { class: "pl-2" }
const _hoisted_208 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_GoogleDriveUploader = _resolveComponent("GoogleDriveUploader")!
  const _component_dotsLoader = _resolveComponent("dotsLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(this.onBoardObject?.organizationName || "organisations"), 1)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isSmallScreen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["absolute left-0 cursor-pointer", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === 0 || _ctx.currentGroupIndex === 0) && _ctx.isSmallScreen }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTabs('left')))
            }, _hoisted_8, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["absolute right-0 cursor-pointer", { 'disabled pointer-events-none': (_ctx.selectedTabIndex === _ctx.carouselHead.length - 1 || _ctx.currentGroupIndex >= _ctx.totalGroups - 1) && _ctx.isSmallScreen }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollTabs('right')))
            }, _hoisted_10, 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["pb-1", _ctx.selectedTabIndex == tab.id ? 'adjust header text-sm font-semibold text-primary':'text-sm text-disabledgrey']),
                key: index,
                onClick: ($event: any) => (_ctx.toggleTabs(tab))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", {
                    ref_for: true,
                    ref: "actualIndex",
                    class: "cursor-pointer"
                  }, _toDisplayString(tab.displayName), 513),
                  _createElementVNode("div", {
                    class: _normalizeClass([{ progress: _ctx.selectedTabIndex === tab.id }, "h-1 p-0.75 relative rounded"])
                  }, null, 2)
                ])
              ], 10, _hoisted_13))
            }), 128))
          ])
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_ctx.selectedTabIndex == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.onBoardObject.organizationName) = $event)),
                          placeholder: "Organisation Legal Name",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.organizationName.$error || _ctx.isDuplicateData.organizationName)
                                            }]),
                          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.onBoardObject.organizationName.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.organizationName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.organizationName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_ctx.v$.onBoardObject.organizationName.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                                : (_ctx.v$.onBoardObject.organizationName.required && _ctx.v$.onBoardObject.organizationName.restrictLegalNameCharacters.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isDuplicateData.organizationName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.onBoardObject.displayName) = $event)),
                          placeholder: "Display Name",
                          class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': (_ctx.v$.onBoardObject.displayName.$error || _ctx.isDuplicateData.displayName)
											}]),
                          onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.onBoardObject.displayName.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.displayName,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.displayName.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (_ctx.v$.onBoardObject.displayName.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, "Required"))
                                : (_ctx.v$.onBoardObject.displayName.required && _ctx.v$.onBoardObject.displayName.restrictCharacters.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isDuplicateData.displayName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.onBoardObject.websiteUrl) = $event)),
                            placeholder: "Website Url",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.websiteUrl.$error || _ctx.isDuplicateData.websiteUrl)
                                                }]),
                            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.onBoardObject.websiteUrl.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.websiteUrl,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.websiteUrl.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (_ctx.v$.onBoardObject.websiteUrl.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Required"))
                                  : (_ctx.v$.onBoardObject.websiteUrl.required && _ctx.v$.onBoardObject.websiteUrl.restrictWebsiteCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, "Charcter Limit is exceeded"))
                                    : (_ctx.v$.onBoardObject.websiteUrl.required &&  _ctx.v$.onBoardObject.websiteUrl.websiteValidate.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Invalid Website"))
                                      : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isDuplicateData.websiteUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.onBoardObject.organizationKey) = $event)),
                            placeholder: "Organisation Key",
                            class: _normalizeClass(["inputboxstyling mt-2", {
													'is-invalid': (_ctx.v$.onBoardObject.organizationKey.$error || _ctx.isDuplicateData.organizationKey)
												}]),
                            onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.onBoardObject.organizationKey.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.organizationKey,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.organizationKey.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                (_ctx.v$.onBoardObject.organizationKey.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, "Required"))
                                  : (_ctx.v$.onBoardObject.organizationKey.required && _ctx.v$.onBoardObject.organizationKey.restrictOrgKeyCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.isDuplicateData.organizationKey)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.onBoardObject.region) = $event)),
                            placeholder: "Region",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.region.$error)
                                                }]),
                            onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.onBoardObject.region.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.region,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.region.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                (_ctx.v$.onBoardObject.region.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Required"))
                                  : (_ctx.v$.onBoardObject.region.required && _ctx.v$.onBoardObject.region.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.onBoardObject.industrySector) = $event)),
                            placeholder: "Industry Sector",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.industrySector.$error)
                                                }]),
                            onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.onBoardObject.industrySector.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.industrySector,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.industrySector.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                (_ctx.v$.onBoardObject.industrySector.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, "Required"))
                                  : (_ctx.v$.onBoardObject.industrySector.required && _ctx.v$.onBoardObject.industrySector.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_67, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", null, [
                        _hoisted_69,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.onBoardObject.addressLineOne) = $event)),
                          placeholder: "Address line - 1",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.addressLineOne.$error)
                                            }]),
                          onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.onBoardObject.addressLineOne.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.addressLineOne,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.addressLineOne.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                              (_ctx.v$.onBoardObject.addressLineOne.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_71, "Required"))
                                : (_ctx.v$.onBoardObject.addressLineOne.restrictCharacters300.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", null, [
                        _hoisted_74,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.onBoardObject.addressLineTwo) = $event)),
                          placeholder: "Address line - 2",
                          class: _normalizeClass(["inputboxstyling mt-2", {
                                                'is-invalid': (_ctx.v$.onBoardObject.addressLineTwo.$error)
                                            }]),
                          onInput: _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.onBoardObject.addressLineTwo.$touch()))
                        }, null, 34), [
                          [
                            _vModelText,
                            _ctx.onBoardObject.addressLineTwo,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.onBoardObject.addressLineTwo.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                              (_ctx.v$.onBoardObject.addressLineTwo.restrictCharacters300.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_76, "Charcter Limit is exceeded"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.onBoardObject.city) = $event)),
                            placeholder: "City",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.city.$error)
                                                }]),
                            onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.v$.onBoardObject.city.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.city,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.city.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                (_ctx.v$.onBoardObject.city.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, "Required"))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.onBoardObject.city.restrictCharacters.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, "Charcter Limit is exceeded"))
                                  : (_ctx.v$.onBoardObject.city.required && _ctx.v$.onBoardObject.city.textOnly.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, "Only letters and spaces are allowed."))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.onBoardObject.state) = $event)),
                            onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.onBoardObject.state.$touch())),
                            placeholder: "State",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.state.$error)
                                                }])
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.state,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.state.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                (_ctx.v$.onBoardObject.state.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, "Required"))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.onBoardObject.state.restrictCharacters.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, "Charcter Limit is exceeded"))
                                  : (_ctx.v$.onBoardObject.state.required && _ctx.v$.onBoardObject.state.textOnly.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, "Only letters and spaces are allowed."))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _hoisted_94,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.onBoardObject.country) = $event)),
                            onInput: _cache[23] || (_cache[23] = ($event: any) => (_ctx.v$.onBoardObject.country.$touch())),
                            placeholder: "Country",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.country.$error)
                                                }])
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.country,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.country.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                (_ctx.v$.onBoardObject.country.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_96, "Required"))
                                  : _createCommentVNode("", true),
                                (_ctx.v$.onBoardObject.country.restrictCharacters.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_97, "Charcter Limit is exceeded"))
                                  : (_ctx.v$.onBoardObject.country.required && _ctx.v$.onBoardObject.country.textOnly.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, "Only letters and spaces are allowed."))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _hoisted_100,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.onBoardObject.pinCode) = $event)),
                            type: "number",
                            placeholder: "Pincode",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.pinCode.$error)
                                                }]),
                            onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.onBoardObject.pinCode.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.pinCode,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.pinCode.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                (_ctx.v$.onBoardObject.pinCode.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, "Required"))
                                  : (_ctx.v$.onBoardObject.pinCode.required && _ctx.v$.onBoardObject.pinCode.pin.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, "Pincode is Invalid"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.onBoardObject.primaryContactName) = $event)),
                            placeholder: "Primary Contact Name",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.primaryContactName.$error)
                                                }]),
                            onInput: _cache[27] || (_cache[27] = ($event: any) => (_ctx.v$.onBoardObject.primaryContactName.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.primaryContactName,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.primaryContactName.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                                (_ctx.v$.onBoardObject.primaryContactName.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, "Required"))
                                  : (_ctx.v$.onBoardObject.primaryContactName.required && _ctx.v$.onBoardObject.primaryContactName.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_110, "Charcter Limit is exceeded"))
                                    : (_ctx.v$.onBoardObject.primaryContactName.required && _ctx.v$.onBoardObject.primaryContactName.textOnly.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_111, "Only letters and spaces are allowed."))
                                      : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _hoisted_113,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.onBoardObject.primaryContactEmail) = $event)),
                            placeholder: "Primary Contact Mail id",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                    'is-invalid': (_ctx.v$.onBoardObject.primaryContactEmail.$error)
                                                }]),
                            onInput: _cache[29] || (_cache[29] = ($event: any) => (_ctx.v$.onBoardObject.primaryContactEmail.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.primaryContactEmail,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.primaryContactEmail.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                (_ctx.v$.onBoardObject.primaryContactEmail.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, "Required"))
                                  : (_ctx.v$.onBoardObject.primaryContactEmail.required && _ctx.v$.onBoardObject.primaryContactEmail.email.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, "Mail Id is Invalid"))
                                    : (_ctx.v$.onBoardObject.primaryContactEmail.required && _ctx.v$.onBoardObject.primaryContactEmail.restrictCharacters50.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _hoisted_121,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.onBoardObject.jobTitle) = $event)),
                            placeholder: "Job Title",
                            class: _normalizeClass(["inputboxstyling mt-2", {
                                                        'is-invalid': (_ctx.v$.onBoardObject.jobTitle.$error)
                                                    }]),
                            onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.v$.onBoardObject.jobTitle.$touch())),
                            onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.handleOrgFormScroll && _ctx.handleOrgFormScroll(...args)))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.onBoardObject.jobTitle,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.onBoardObject.jobTitle.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                (_ctx.v$.onBoardObject.jobTitle.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, "Required"))
                                  : (_ctx.v$.onBoardObject.jobTitle.required && _ctx.v$.onBoardObject.jobTitle.restrictCharacters.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, "Charcter Limit is exceeded"))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_125, [
                          _hoisted_126,
                          _createElementVNode("input", {
                            value: _ctx.onBoardObject.departments || 'N/A',
                            placeholder: "Team",
                            class: "inputboxstyling mt-2 p-inputtext",
                            disabled: ""
                          }, null, 8, _hoisted_127)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                      _hoisted_129,
                      (_ctx.onBoardObject.logoUrl == '')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([{'is-invalid borderRed': _ctx.v$.fileName.$error,}, "border w-full rounded py-2 border-lightgrey"])
                          }, [
                            _createElementVNode("div", _hoisted_130, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_131, [
                                  _createElementVNode("label", {
                                    htmlFor: _ctx.onBoardObject,
                                    class: "mt-2"
                                  }, _hoisted_134, 8, _hoisted_132),
                                  _createElementVNode("label", { htmlFor: _ctx.onBoardObject }, [
                                    (_openBlock(), _createElementBlock("input", {
                                      type: "file",
                                      id: _ctx.onBoardObject,
                                      style: {"display":"none"},
                                      ref: "fileInput",
                                      onChange: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.imageCheckFile('fileInput','add')), ["stop"])),
                                      key: _ctx.fileInputKey
                                    }, null, 40, _hoisted_136))
                                  ], 8, _hoisted_135)
                                ]),
                                _createElementVNode("div", _hoisted_137, [
                                  (_ctx.fileName!='')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                                        _createTextVNode("Selected File : "),
                                        _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.fileName), 1)
                                      ]))
                                    : (_ctx.fileName == '')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_140, _toDisplayString('Click on the icon for uploading a file')))
                                      : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ], 2))
                        : (_ctx.onBoardObject.logoUrl !='')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                              _createElementVNode("div", null, [
                                _createElementVNode("label", {
                                  htmlFor: _ctx.onBoardObject,
                                  class: "mt-2 flex justify-center p-2 items-center"
                                }, [
                                  _createElementVNode("img", {
                                    src: _ctx.onBoardObject.logoUrl,
                                    alt: "",
                                    class: "w-20 h-20 cursor-pointer"
                                  }, null, 8, _hoisted_143)
                                ], 8, _hoisted_142),
                                _createElementVNode("label", {
                                  htmlFor: _ctx.onBoardObject,
                                  onChange: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.imageCheckFile('fileInput','edit')), ["stop"]))
                                }, [
                                  (_openBlock(), _createElementBlock("input", {
                                    type: "file",
                                    id: _ctx.onBoardObject,
                                    style: {"display":"none"},
                                    ref: "fileInput",
                                    key: _ctx.fileInputKey
                                  }, null, 8, _hoisted_145)),
                                  _hoisted_146
                                ], 40, _hoisted_144)
                              ]),
                              _createElementVNode("div", _hoisted_147, [
                                (_ctx.fileName!='')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                      _createTextVNode("Selected File : "),
                                      _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.fileName), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                    ])
                  ], 512)
                ]),
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary mr-2", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onCancel('org')))
                    }, "Cancel", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.updateOrganization(_ctx.onBoardObject)))
                    }, "Update", 10, _hoisted_152)
                  ])
                ])
              ])
            ]))
          : (_ctx.selectedTabIndex == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _createElementVNode("div", _hoisted_157, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allApps, (apps) => {
                          return (_openBlock(), _createElementBlock("label", {
                            key: apps,
                            class: "w-28 h-28 border border-lightgrey rounded",
                            style: {"width":"190px","height":"140px"},
                            onChange: ($event: any) => (_ctx.selectCheckBoxApps(apps))
                          }, [
                            _createElementVNode("div", _hoisted_159, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "cursor-pointer checkbox absolute top-3 left-3",
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.selectedApps) = $event)),
                                value: apps
                              }, null, 8, _hoisted_160), [
                                [_vModelCheckbox, _ctx.selectedApps]
                              ]),
                              _createElementVNode("div", _hoisted_161, _toDisplayString(apps.appName), 1)
                            ])
                          ], 40, _hoisted_158))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_162, [
                    _createElementVNode("div", _hoisted_163, [
                      _createElementVNode("button", {
                        class: _normalizeClass([_ctx.disableSelectedAppStatus ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary mr-2"]),
                        onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.onCancel('apps')))
                      }, "Cancel", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass([_ctx.disableSelectedAppStatus ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.updateSelectedApps()))
                      }, "Update", 10, _hoisted_164)
                    ])
                  ])
                ])
              ]))
            : (_ctx.selectedTabIndex == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                  _createElementVNode("div", _hoisted_166, [
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _createElementVNode("div", _hoisted_169, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFrameworks, (framework) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: framework,
                              class: _normalizeClass(["w-28 h-28 border border-lightgrey rounded", framework?.controlFrameWork  == 'InternalControls' || framework?.name == 'InternalControls'? 'disabled pointer-events-none':'']),
                              style: {"width":"190px","height":"140px"},
                              onChange: ($event: any) => (_ctx.selectCheckBoxFrameworks(framework))
                            }, [
                              _createElementVNode("div", _hoisted_171, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "cursor-pointer checkbox absolute top-3 left-3",
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.selectedFrameWorks) = $event)),
                                  value: framework
                                }, null, 8, _hoisted_172), [
                                  [_vModelCheckbox, _ctx.selectedFrameWorks]
                                ]),
                                _createElementVNode("div", _hoisted_173, _toDisplayString(framework?.controlFrameWork || framework?.name || 'N/A'), 1)
                              ])
                            ], 42, _hoisted_170))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, [
                      _createElementVNode("div", _hoisted_175, [
                        _createElementVNode("button", {
                          class: _normalizeClass([_ctx.disableSelectedFrameworkStatus ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary mr-2"]),
                          onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onCancel('frameworks')))
                        }, "Cancel", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass([_ctx.disableSelectedFrameworkStatus ? 'btndisabled pointer-events-none' : 'btnprimary', "btnprimary"]),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.updateSelectedFrameworks()))
                        }, "Update", 10, _hoisted_176)
                      ])
                    ])
                  ])
                ]))
              : (_ctx.selectedTabIndex == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                    _createElementVNode("div", _hoisted_178, [
                      _createElementVNode("div", _hoisted_179, [
                        _createElementVNode("div", _hoisted_180, [
                          _createElementVNode("div", _hoisted_181, [
                            _createElementVNode("div", _hoisted_182, [
                              _hoisted_183,
                              _createElementVNode("div", _hoisted_184, [
                                (_ctx.newHistory)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: _normalizeClass(["btnprimary w-24 flex taskEditButtons", _ctx.workLogObject?.[0] && Object.keys(_ctx.workLogObject[0]).includes('tenantHistory') && _ctx.workLogObject[0].tenantHistory?.length !== 0 ? 'btnprimary' : 'pointer-events-none']),
                                      onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.sortWorkLog()))
                                    }, [
                                      _hoisted_185,
                                      _createTextVNode(" Oldest ")
                                    ], 2))
                                  : _createCommentVNode("", true),
                                (!_ctx.newHistory)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btnprimary w-24 flex taskEditButtons",
                                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.sortWorkLog()))
                                    }, [
                                      _hoisted_186,
                                      _createTextVNode(" Newest ")
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject[0]?.tenantHistory, (work) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: work,
                                class: "bg-white p-4 mb-0.5 border-lightgrey border-b w-full"
                              }, [
                                _createElementVNode("div", _hoisted_187, [
                                  (Object.keys(work).includes('updatedBy'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_188, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(work.updatedBy))), 1))
                                    : (Object.keys(work).includes('createdBy'))
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_189, _toDisplayString(_ctx.extractInitials(_ctx.getPersonName(work.createdBy))), 1))
                                      : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_190, [
                                    _createElementVNode("div", _hoisted_191, [
                                      (Object.keys(work).includes('createdBy'))
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_192, _toDisplayString(_ctx.getPersonName(work.createdBy)), 1))
                                        : (Object.keys(work).includes('updatedBy'))
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_193, _toDisplayString(_ctx.getPersonName(work.updatedBy)), 1))
                                          : _createCommentVNode("", true),
                                      (work.appName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                                            (work.updatedInfo==false)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_195, [
                                                  _createTextVNode(_toDisplayString('Removed access for') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.appName}`), 1),
                                                  _createTextVNode(" " + _toDisplayString('in') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.updatedIn}`), 1),
                                                  _createElementVNode("span", _hoisted_196, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                ]))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_197, [
                                                  _createTextVNode(_toDisplayString('Granted access for') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.appName}`), 1),
                                                  _createTextVNode(" " + _toDisplayString('in') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.updatedIn}`), 1),
                                                  _createElementVNode("span", _hoisted_198, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                ]))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (work.frameworkName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                                            (work.updatedInfo==false)
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_200, [
                                                  _createTextVNode(_toDisplayString('Removed access for') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.frameworkName}`), 1),
                                                  _createTextVNode(" " + _toDisplayString('in') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.updatedIn}`), 1),
                                                  _createElementVNode("span", _hoisted_201, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                ]))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_202, [
                                                  _createTextVNode(_toDisplayString('Granted access for') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.frameworkName}`), 1),
                                                  _createTextVNode(" " + _toDisplayString('in') + " "),
                                                  _createElementVNode("b", null, _toDisplayString(`${work.updatedIn}`), 1),
                                                  _createElementVNode("span", _hoisted_203, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                                ]))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (work.actionType && work.actionType==10301 && Object.keys('orgDisplayName')&& work.orgDisplayName)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                            _createElementVNode("p", null, [
                                              _createTextVNode(_toDisplayString('Created the ') + " "),
                                              _createElementVNode("b", null, _toDisplayString(`${work.orgDisplayName}`), 1),
                                              _createTextVNode(" " + _toDisplayString('at')),
                                              _createElementVNode("span", _hoisted_205, _toDisplayString(_ctx.formatTime(work.createdAt)), 1)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (!work.appName&& !work.frameworkName && !work.tenantName)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_206, [
                                            _createTextVNode(_toDisplayString('Updated the') + " " + _toDisplayString(`${work.updatedIn}`) + " " + _toDisplayString('from') + " ", 1),
                                            _createElementVNode("b", null, _toDisplayString(`${work.previousInfo}`), 1),
                                            _createTextVNode(" " + _toDisplayString('to') + " "),
                                            _createElementVNode("b", null, _toDisplayString(`${work.updatedInfo}`), 1),
                                            _createElementVNode("span", _hoisted_207, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                : (_ctx.selectedTabIndex == 4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                      _createVNode(_component_GoogleDriveUploader)
                    ]))
                  : _createCommentVNode("", true)
      ]),
      (_ctx.dotsLoader)
        ? (_openBlock(), _createBlock(_component_dotsLoader, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}